import '~packs/public_credentials/styles/application.css';

document.addEventListener('DOMContentLoaded', function () {
  const pageUrl = document.querySelector('meta[property="og:url"]').content;

  let copyButton = document.querySelector('.copyButton');
  if (typeof copyButton !== 'undefined' && copyButton != null) {
    copyButton.addEventListener('click', (e) => {
      e.preventDefault();
      copyToClipboard(
        `${pageUrl}?utm_source=platform&utm_medium=web&utm_campaign=copy_link_button`
      );
      document.querySelector('.copyButton').classList.add('min-w-24');
      const copyButtonText = document.querySelector('.copyButtonText');
      copyButtonText.textContent = 'Link copied!';
      copyButtonText.classList.add('text-success-dark');
      window.scrollTo(0, 0);
    });
  }

  let shareButton = document.querySelector('.shareButton');
  if (typeof shareButton !== 'undefined' && shareButton != null) {
    shareButton.addEventListener('click', () => {
      document.querySelector('.shareButtonHolder').classList.add('hidden');
      document.querySelector('.shareOptions').classList.remove('opacity-0');
      document.querySelector('.shareOptions').classList.remove('pointer-events-none');
    });
  }

  document.querySelectorAll('.imageOption').forEach((option) => {
    option.addEventListener('click', () => {
      let id = option.querySelector('img').getAttribute('data-id');
      let filename = option.querySelector('img').getAttribute('data-filename');
      let downloadUrl = option.querySelector('img').getAttribute('src');
      let imageHolder = document.querySelector('.imageHolder');
      updateCurrentVariation(id);
      updateDownloadLink(downloadUrl, filename);

      imageHolder.style.display = 'block';
      document.querySelector('.imageOptionsHolder').style.display = 'none';
      imageHolder.querySelector('img').setAttribute('src', `${downloadUrl}?w=1200&h=630`);
    });
  });

  let editImage = document.querySelector('.editImage');
  if (typeof editImage !== 'undefined' && editImage != null) {
    editImage.addEventListener('click', () => {
      document.querySelector('.imageOptionsHolder').style.display = 'block';
      document.querySelector('.imageHolder').style.display = 'none';
    });
  }

  let closeBannerButton = document.querySelector('#close-banner-button');
  if (typeof closeBannerButton !== 'undefined' && closeBannerButton != null) {
    const url = document.querySelector('#close-banner-button').getAttribute('data-url');
    closeBannerButton.addEventListener('click', () => {
      document.querySelector('.banner').style.display = 'none';
      request(url, 'POST', null);
    });
  }

  function updateDownloadLink(downloadUrl, filename) {
    let downloadLink = document.querySelector('#credential-download-button');
    downloadLink.setAttribute('href', `${downloadUrl}?dl=${filename}`);
  }

  async function updateCurrentVariation(id = '') {
    const url = document.querySelector('#variations-container').getAttribute('data-url');

    request(url, 'PATCH', { selected_variation: id });
  }

  async function request(url = '', method = 'PATCH', body = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    return fetch(url, {
      method: method,
      mode: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify(body),
    });
  }

  function copyToClipboardFallback(txt) {
    let tmpInput = document.createElement('input');
    tmpInput.value = txt;

    document.body.appendChild(tmpInput);
    tmpInput.focus();
    tmpInput.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('(f) unable to copy: ', err);
    }

    document.body.removeChild(tmpInput);
  }

  function copyToClipboard(txt) {
    if (!navigator.clipboard) {
      copyToClipboardFallback(txt);
      return;
    }

    navigator.clipboard.writeText(txt).then(
      function () {},
      function (err) {
        console.error('unable to copy: ', err);
      }
    );
  }
});
